import React, { Component } from "react";
import { loading, Navbar, copyText } from "../../components/CustomComponent.js";

// Chat types Telegram reports on chat objects; anything else falls back to "chat".
const CHAT_TYPE_META = {
  supergroup: { label: "Supergroup", icon: "\uf0c0" },
  group: { label: "Group", icon: "\uf0c0" },
  channel: { label: "Channel", icon: "\uf0a1" },
  private: { label: "Private", icon: "\uf007" },
};

export default class TelegramRooms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loaded: false,
      filter_search: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get();
  }
  // ดึง update ล่าสุดจาก bot แล้วเหลือห้องละหนึ่งรายการ (ตัดซ้ำด้วย chat id) — เหมือนเดิม
  Get = async () => {
    loading(true);
    let data = [];
    try {
      const response = await fetch(atob(global.tlgr), {
        method: "GET",
        headers: { "Content-Type": "application/json", accept: "application/json" },
        cache: "no-cache",
      });
      const result = await response.json();
      data = [
        ...new Map(
          (result?.result || []).map((e) => {
            const item = e.my_chat_member || e.message;
            return [
              item?.chat?.id,
              {
                id: item?.chat?.id,
                name: item?.chat?.title,
                type: item?.chat?.type,
              },
            ];
          })
        ).values(),
      ];
    } catch (err) {
      data = [];
    }
    this.setState({ data, loaded: true });
    loading(false);
  };
  render() {
    const { data, loaded, filter_search } = this.state;
    const q = filter_search.trim().toLowerCase();
    const rows = (Array.isArray(data) ? data : []).filter(
      (e) =>
        !q ||
        String(e.id ?? "").toLowerCase().includes(q) ||
        String(e.name ?? "").toLowerCase().includes(q)
    );
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          {/* HERO */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Configuration</div>
                <div className="ar-title">Telegram Rooms</div>
                <div className="ar-subtitle">
                  Chat rooms the notification bot has joined. Use the Chat ID when
                  configuring a broker's notify room.
                </div>
              </div>
              <div className="d-flex align-items-end gap-4">
                <div className="ar-hero-actions">
                <button className="ar-btn-ghost" onClick={() => this.Get()}>
                  <span className="icon me-2">{"\uf2f1"}</span>Refresh
                </button>
                </div>
                <div className="text-end d-none d-md-block">
                  <div className="ar-year">{data.length}</div>
                  <div className="ar-year-caption justify-content-end">
                    room{data.length === 1 ? "" : "s"}
                  </div>
                </div>
              </div>
            </div>

            <div className="ar-toolbar ar-filter mt-3">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label">
                  <span className="icon me-2">{"\uf0b0"}</span>Filter
                </span>
              </div>
              <div className="ar-filter-row">
                <div className="ar-filter-field ar-filter-field-search">
                  <span className="ar-filter-label">Search</span>
              <input
                type="text"
                className="form-control"
                placeholder="Search chat id or group name..."
                onChange={(e) => this.setState({ filter_search: e.target.value })}
                value={filter_search}
              />
                </div>
              <div className="ar-toolbar-actions">
              {filter_search && (
                <button
                  className="ar-btn-ghost"
                  onClick={() => this.setState({ filter_search: "" })}
                >
                  Clear
                </button>
              )}
              </div>
              </div>
            </div>
          </div>

          {/* TABLE */}
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{"\uf1d8"}</span>
                  Chat Rooms
                </div>
                <div className="ar-table-caption">
                  {rows.length} of {data.length} room{data.length === 1 ? "" : "s"}
                  {q ? ` · filtered by "${filter_search.trim()}"` : ""}
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover ar-table pu-table">
                <thead>
                  <tr>
                    <td className="text-nowrap wpx-220">Chat ID</td>
                    <td className="text-nowrap">Group Name</td>
                    <td className="text-nowrap wpx-140">Type</td>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((item, index) => {
                    const meta = CHAT_TYPE_META[item.type] || {
                      label: item.type || "Chat",
                      icon: "\uf075",
                    };
                    const name = item.name || "-";
                    return (
                      <tr key={item.id ?? `array-${index}`}>
                        <td data-label="ID" className="text-nowrap">
                          <div className="pu-email">
                            <span className="pu-code">{item.id ?? "-"}</span>
                            {item.id !== undefined && item.id !== null && (
                              <span
                                className="icon pu-copy pointer"
                                title="Copy chat id"
                                onClick={() => copyText(String(item.id))}
                              >
                                {"\uf0c5"}
                              </span>
                            )}
                          </div>
                        </td>
                        <td data-label="Name" className="text-nowrap">
                          <div className="pu-user">
                            <div className="pu-avatar">
                              {name.trim().charAt(0).toUpperCase() || "#"}
                            </div>
                            <div className="min-w-0">
                              <div className="pu-name text-truncate" title={name}>
                                {name}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td data-label="Type" className="text-nowrap">
                          <span className="pu-flag on">
                            <span className="icon">{meta.icon}</span>
                            {meta.label}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                  {loaded && rows.length === 0 && (
                    <tr>
                      <td colSpan={3} className="p-0 border-0">
                        <div className="pr-empty rounded-0 border-0">
                          <span className="icon">{"\uf1d8"}</span>
                          <div className="fw-bold">
                            {q ? "No room matches your search" : "No chat room found"}
                          </div>
                          <div className="text-secondary text-14">
                            {q
                              ? "Try another chat id or group name."
                              : "Add the bot to a Telegram group, then refresh."}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
